






    import { Component, Prop, Vue } from "vue-property-decorator";
    import VideoPlayer from "@/components/VideoPlayer.vue";

@Component({  
    props: {
        urlVideo : String,
        posterVideo : String
    },
    data(){
        return{
            /* Video */
            videosRc:{
                video:{
                    autoplay: false,
                    controls: true,
                    fluid: true,
                    preload: 'auto',
                    sources: [
                        {
                            src: this.$props.urlVideo,
                            type: "video/mp4"
                        }
                    ],
                    poster: this.$props.posterVideo ? this.$props.posterVideo : null,
                   /*  controlBar: {
                        'liveDisplay': true,
                        'pictureInPictureToggle': false,
                        'fullscreenToggle': true,
                        'volumePanel': true
                    } */
                }
            },
        }
    },
    components: {
        VideoPlayer,
    }
})

export default class Alerts extends Vue {}
